"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const lab_1 = require("@material-ui/lab");
const styles_1 = require("@material-ui/styles");
const expertsSlice_1 = require("../../../../../redux/slices/expertsSlice");
const parent_1 = __importDefault(require("./parent"));
const children_1 = __importDefault(require("./children"));
const styles_2 = __importDefault(require("./styles"));
const FilterItem = (props) => {
    const { data, classes } = props;
    const nodeId = `${data.name + data.id}`;
    const label = data.subCategories ? react_1.default.createElement(parent_1.default, Object.assign({}, props)) : react_1.default.createElement(children_1.default, { props: Object.assign({}, props) });
    const children = data.subCategories ? data.subCategories.map((val, key) => (react_1.default.createElement(children_1.default, { key: key, props: Object.assign(Object.assign({}, props), { data: val }) }))) : [];
    return data.subCategories ? react_1.default.createElement(lab_1.TreeItem, { className: 'parent-item', key: data.id, nodeId: nodeId, children: children, label: label, classes: {
            content: classes.content
        } }) : label;
};
const mapStateToProps = (state) => {
    const { experts } = state;
    return {
        filters: experts.filter
    };
};
const mapDispatchToProps = (dispatch) => {
    return {
        getExperts: (data) => dispatch(expertsSlice_1.getExperts(data)),
        getServiceExperts: (data) => dispatch(expertsSlice_1.getServiceExperts(data))
    };
};
exports.default = react_redux_1.connect(mapStateToProps, mapDispatchToProps)(styles_1.withStyles(styles_2.default)(FilterItem));
